import React from 'react';
import { SITE_CONFIG } from '../../data/constants';
import './MessengerBubble.css';

const MessengerBubble: React.FC = () => {
  return (
    <a
      className="messenger-bubble"
      href={SITE_CONFIG.messengerUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Napisz do nas na Messengerze"
      title="Napisz do nas na Messengerze"
    >
      <span className="messenger-bubble__icon" aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          width="28"
          height="28"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M12 2C6.477 2 2 6.086 2 11.127c0 2.874 1.428 5.44 3.663 7.118V22l3.436-1.887c.915.251 1.883.388 2.901.388 5.523 0 10-4.086 10-9.127S17.523 2 12 2zm1.033 11.957-2.548-2.72-4.985 2.72 5.486-5.83 2.548 2.72 4.966-2.72-5.467 5.83z"
          />
        </svg>
      </span>
      <span className="messenger-bubble__text">Napisz do nas</span>
    </a>
  );
};

export default MessengerBubble;
